import { useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getUploadedDocuments } from "../../services/apiUser";

export function useGetUploadDocuments() {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["uploadedDocuments"],
    queryFn: getUploadedDocuments,
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["uploadedDocuments"], (oldList) =>
        oldList?.map((doc) => ({ ...doc, status: "Done" }))
      );
    },
  });
}
